import React from 'react';
import PropTypes from 'prop-types';
import { TRANSITION_DURATION } from '../../../components/SlideManager';
import { SegmentTypeProps } from '../../../models';
import { Fragment } from './Fragment';

export const FocusableFragment = ({ children, id, isDone, setValue }) => {
    const [focus, setFocus] = React.useState(false);

    const onEntered = () => setTimeout(() => setFocus(true), TRANSITION_DURATION);

    const onExiting = () => setFocus(false);

    return (
        <Fragment
            id={id}
            isDone={isDone}
            isEmpty={!isDone}
            onEntered={onEntered}
            onExiting={onExiting}
            setValue={setValue}
        >
            {({ onSelectValue }) => children({ focus, onSelectValue })}
        </Fragment>
    );
};

FocusableFragment.propTypes = {
    children: PropTypes.func.isRequired,
    id: SegmentTypeProps.isRequired,
    isDone: PropTypes.bool.isRequired,
    setValue: PropTypes.func.isRequired,
};
